import type { ReactNode } from 'react';

export interface Column<T> {
  header: string;
  accessor: (row: T) => ReactNode;
  /** Applied to both the header and body cell — e.g. `text-right font-mono tabular-nums` for numbers. */
  className?: string;
}

export function Table<T>({
  columns,
  rows,
  getRowKey,
}: {
  columns: Column<T>[];
  rows: T[];
  getRowKey: (row: T) => string;
}) {
  return (
    <div className="overflow-x-auto rounded-card border border-line bg-surface-1 shadow-card">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="h-9 border-b border-line">
            {columns.map((col) => (
              <th
                key={col.header}
                scope="col"
                className={`whitespace-nowrap px-4 text-left font-mono text-[11px] font-medium uppercase tracking-[0.06em] text-fg-muted ${col.className ?? ''}`}
              >
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={getRowKey(row)}
              className="h-12 border-b border-line transition-colors duration-fast last:border-b-0 hover:bg-surface-2"
            >
              {columns.map((col) => (
                <td key={col.header} className={`whitespace-nowrap px-4 py-2 text-fg ${col.className ?? ''}`}>
                  {col.accessor(row)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
